import { host } from './products';

export function login(form: { email: string; password: string }) {
  return fetch(`${host}/v1/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(form),
  });
}
